import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    size?: number;
}

export const Wrench = (props: Props) => {
    const size = props.size ?? 24;
    const color = props.color ?? resolveColor("--theme-primary");

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.2214 6.7478C14.0363 6.93665 13.9326 7.19055 13.9326 7.45499C13.9326 7.71943 14.0363 7.97332 14.2214 8.16217L15.8378 9.77859C16.0267 9.9637 16.2806 10.0674 16.545 10.0674C16.8095 10.0674 17.0634 9.9637 17.2522 9.77859L21.0609 5.9699C21.5689 7.09249 21.7227 8.34324 21.5018 9.55547C21.281 10.7677 20.6959 11.8838 19.8246 12.7551C18.9533 13.6264 17.8372 14.2115 16.625 14.4323C15.4128 14.6532 14.162 14.4994 13.0394 13.9914L6.05851 20.9723C5.6566 21.3742 5.1115 21.6 4.54311 21.6C3.97473 21.6 3.42963 21.3742 3.02772 20.9723C2.62581 20.5704 2.40002 20.0253 2.40002 19.4569C2.40002 18.8885 2.62581 18.3434 3.02772 17.9415L10.0086 10.9606C9.50064 9.83801 9.34683 8.58725 9.5677 7.37503C9.78857 6.1628 10.3736 5.04668 11.2449 4.17539C12.1162 3.30411 13.2323 2.71905 14.4446 2.49818C15.6568 2.27731 16.9075 2.43112 18.0301 2.93911L14.2315 6.7377L14.2214 6.7478Z"
                stroke={color}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
